import { Box, Divider, Text } from '@chakra-ui/react'
import React from 'react'
import Image from 'next/legacy/image'
import { useTranslation } from 'next-i18next'
import { engraveOptionName } from 'modules/product/utils/engraveOptionName'
import ImageDropzone from '_app/components/Form/ImageDropzone'
import { EngraveTabComponentProps } from '_app/types/product'
import getCurrency from '_app/utils/localized/getCurrency'
import PriceText from '_app/components/PriceText'
import { useRouter } from '_app/hooks/useRouter'

const EngravingPhoto = ({
  option,
  onAddOption,
  onDeleteOption,
}: EngraveTabComponentProps) => {
  const { t } = useTranslation(['dropzone', 'engraving'])
  const { locale } = useRouter()
  const inputName = `${engraveOptionName(option)}.file`

  return (
    <Box>
      <Text
        mb={3}
        mt={{ base: 2, md: 0.5 }}
        fontWeight={300}
        flexDirection="row"
        display="flex"
      >
        {t('PHOTO_ENGRAVING_PRICE', { ns: 'engraving' })}:
        <Text pl={1} fontWeight={400}>
          <PriceText
            amount={{
              value: option.value?.price,
              currency: getCurrency(locale),
            }}
            floating
          />
        </Text>
      </Text>
      <Divider mb={6} />
      <Box borderBottom="1px" borderColor="#e5e5e5" pb={6}>
        <Text fontWeight="normal" fontSize="md" pb={4}>
          {t('')}
        </Text>
        <Box
          display={{
            base: 'none',
            md: 'block',
          }}
        >
          <Image
            alt=""
            src="/images/product/drawer/engr-photo/desktop.png"
            width="1710"
            height="999"
            layout="responsive"
            sizes="570px"
          />
        </Box>
        <Box
          display={{
            base: 'block',
            md: 'none',
          }}
        >
          <Image
            alt=""
            src="/images/product/drawer/engr-photo/mobile.jpg"
            height="924"
            width="870"
            layout="responsive"
            sizes="551px"
          />
        </Box>
      </Box>

      <Box mb={4}>
        <Text fontWeight="normal" pt={6} pb={4}>
          {t('YOUR_GRAPHICS', { ns: 'engraving' })}
        </Text>
        <Box display="flex" flexDirection="row" alignItems="end">
           <ImageDropzone
            name={inputName}
            label={t('DROPZONE_INFO')}
            accept={['image/jpeg', 'image/png']}
            onAddHandler={onAddOption}
            onRemoveHandler={onDeleteOption}
            maxSize={2097152}
           />
        </Box>
      </Box>
    </Box>
  )
}

export default EngravingPhoto
